import React, { useState, useEffect, useRef } from "react";
import ReactModal from "react-modal";
import styles from "./Styles";
import RadioBoxEmpty from "../../controls/check-boxes/RadioBoxEmpty";
import {
    OnestNormal,
    OnestNormalDefault,
    OnestNormalSmall,
    OnestMediumDefault,
    OnestMediumSmall,
} from "../../styled/TextComponents";
import { Button } from "../../controls/Button/Button";
import {
    color_white,
    color_grey_light,
    color_grey_ultra_light,
    color_red_default,
} from "../../../constants/colors";
import minutesToStr from "../../../utilities/munutesToStr";
import moment from "moment-timezone";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import { useWindowDimensions } from "../../../utils";
import IconlyCurvedLightCalendar from "../../icons/IconlyCurvedLightCalendar";
import { MODAL_Z_INDEX_BASE } from "../../../constants/layers";
import {
    bottomSheetDragHandleVisualStyle,
    useBottomSheetDrag,
} from "../../../hooks/useBottomSheetDrag";
import { useI18n } from "../../../i18n/I18nProvider";

const selectArrowIcon = `url("data:image/svg+xml;utf8,<svg width='10' height='5' viewBox='0 0 10 5' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9.40289 1.06497C9.64588 0.819802 9.64411 0.424078 9.39895 0.181091C9.15379 -0.0618949 8.75806 -0.0601294 8.51508 0.185035L7.05899 1.65418C6.46804 2.25042 6.06134 2.65942 5.71673 2.93617C5.38198 3.205 5.16697 3.29723 4.97441 3.32177C4.85349 3.33719 4.73115 3.33719 4.61023 3.32177C4.41767 3.29723 4.20265 3.205 3.86791 2.93617C3.5233 2.65942 3.1166 2.25042 2.52565 1.65418L1.06956 0.185034C0.826576 -0.0601297 0.430851 -0.0618953 0.185687 0.181091C-0.0594773 0.424077 -0.0612424 0.819801 0.181743 1.06497L1.66407 2.56058C2.22235 3.12388 2.67864 3.58428 3.0852 3.91079C3.50797 4.25031 3.93709 4.49609 4.45218 4.56174C4.67804 4.59053 4.9066 4.59053 5.13245 4.56174C5.64755 4.49609 6.07666 4.25031 6.49944 3.91079C6.906 3.58428 7.36228 3.12389 7.92057 2.56057L9.40289 1.06497Z' fill='%23B1B1B1'/></svg>")`;

const ModalReschedule = ({ isOpen, onClose, onSave, lessonData, initialActionMode = "reschedule" }) => {
    const { t, locale } = useI18n();
    const { width: screenWidth } = useWindowDimensions();
    const isMobile = screenWidth <= 500;
    const mobileHorizontalPadding = 16;
    const timeInputWidth = isMobile ? 60 : 72;
    const dateInputRef = useRef(null);
    const isDatePickerOpenRef = useRef(false);

    const user = useSelector(state => state.user)
    const timeZone = user.time_zone || Intl.DateTimeFormat().resolvedOptions().timeZone; // Замените на ваш часовой пояс по умолчанию 

    const gDate = moment(); // Текущее время
    const formattedDate = gDate.tz(timeZone); // Преобразование даты в нужный часовой пояс

    const [actionMode, setActionMode] = useState("reschedule");
    const [selectedDate, setSelectedDate] = useState(moment(lessonData.dateDate).format("YYYY-MM-DD") || formattedDate.format("YYYY-MM-DD"));
    const [selectedTime, setSelectedTime] = useState(lessonData.timeSlot);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [isSpineActive, setIsSpineActive] = useState(false);
    const { dragHandleProps, sheetMotionStyle, resetDrag } = useBottomSheetDrag({
        enabled: isMobile,
        onClose,
    });

    const isDelete = actionMode !== "reschedule";
    const isPaid = actionMode === "delete_paid";

    const handleRescheduleSubmit = async () => {
        setIsSpineActive(true);
        if (!selectedDate || !selectedTime) {
            console.error("Invalid date or time selected");
            setIsSpineActive(false);
            return;
        }

        const dateTime = moment.tz(`${selectedDate}T${selectedTime.split(" - ")[0]}:00`, timeZone);
        const gMomentDateTime = dateTime.utcOffset(0, false).unix(); // Преобразование в UTC и в секунды
        //const globalDateTime = gMomentDateTime.toDate();
        console.warn("gMomentDateTime", gMomentDateTime, 'timeZone', timeZone, 'selectedDate', selectedDate, 'selectedTime', selectedTime);
        let isComleate = await onSave(gMomentDateTime, isDelete, isPaid, lessonData)
        if (isComleate) {
            onClose();
        }
        setIsSpineActive(false);
    };

    const handleTimeChange = (time) => {
        setSelectedTime(time);
        setActionMode("reschedule");
    };
    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
        setActionMode("reschedule");
        isDatePickerOpenRef.current = false;
    };

    const handleClickPayOption = () => {
        setActionMode("delete_paid");
    }

    const handleClickFreeOption = () => {
        setActionMode("delete_free");
    }

    const onAfterOpen = () => {
        console.log("Modal opened for rescheduling");
    };

    useEffect(() => {
        if (!isOpen) {
            return;
        }
        setSelectedTime(lessonData.timeSlot);
        if (lessonData.dateDate) {
            const formattedDate = moment(lessonData.dateDate).format("YYYY-MM-DD");
            setSelectedDate(formattedDate);
        }
        setActionMode(initialActionMode);
        resetDrag();
    }, [isOpen, lessonData, initialActionMode, resetDrag]);

    useEffect(() => {
        if (!isOpen) {
            resetDrag();
            return;
        }
        if (actionMode !== "reschedule") {
            setIsButtonDisabled(false);
            return;
        }
        setIsButtonDisabled(!(selectedDate && selectedTime));
    }, [actionMode, selectedDate, selectedTime, isOpen, resetDrag]);

    /* 
        useEffect(() => {
            if (!isDelete && selectedDate && selectedTime) {
                setIsButtonDisabled(false);
            } else if (isDelete) {
                setIsButtonDisabled(false);
            } else {
                setIsButtonDisabled(true);
            }
        }, [isDelete, selectedDate, selectedTime]);
    
     */
    
    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onClose}
            onAfterOpen={onAfterOpen}
            style={{
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.65)",
                    backdropFilter: "blur(8px)",
                    overflow: "hidden",
                    zIndex: MODAL_Z_INDEX_BASE,
                },
                content: {
                    ...styles.modalContainer,
                    width: isMobile ? "100%" : 418,
                    maxWidth: isMobile ? "100vw" : "calc(100vw - 24px)",
                    padding: isMobile
                        ? `14px ${mobileHorizontalPadding}px calc(16px + env(safe-area-inset-bottom))`
                        : "30px",
                    boxSizing: "border-box",
                    ...(isMobile
                        ? {
                              top: "auto",
                              left: 0,
                              right: 0,
                              bottom: 0,
                              ...sheetMotionStyle,
                          }
                        : {
                              top: styles.modalContainer.top,
                              left: styles.modalContainer.left,
                              right: "auto",
                              bottom: "auto",
                              transform: styles.modalContainer.transform,
                          }),
                    maxHeight: isMobile ? "100dvh" : undefined,
                    overflowY: isMobile ? "auto" : undefined,
                    borderRadius: isMobile ? "20px 20px 0 0" : styles.modalContainer.borderRadius,
                },
            }}
        >
            <style>
                {`
                    .reschedule-date-input::-webkit-calendar-picker-indicator {
                        opacity: 0;
                        display: none;
                        -webkit-appearance: none;
                    }
                    .reschedule-date-input::-webkit-inner-spin-button,
                    .reschedule-date-input::-webkit-clear-button {
                        display: none;
                    }
                `}
            </style>
            {isMobile && (
                <div {...dragHandleProps}>
                    <div style={bottomSheetDragHandleVisualStyle} />
                </div>
            )}
            <div style={{ display: "flex", alignItems: "flex-start" }}>
                <OnestMediumDefault style={{ fontSize: 24 }}>
                    {lessonData.studentName}
                </OnestMediumDefault>
                <div style={{ flexGrow: 1 }} />
                <button
                    type="button"
                    onClick={onClose}
                    style={{
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: -8,
                        marginRight: -6,
                    }}
                    aria-label={t("Закрыть")}
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M18 6L6 18"
                            stroke="#B1B1B1"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M6 6L18 18"
                            stroke="#B1B1B1"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            </div>
            <OnestMediumSmall
                style={{
                    color: lessonData.lessonStatusColor,
                    marginTop: 8,
                    marginBottom: 8,
                }}>
                {t(lessonData.paymentStatus)}
            </OnestMediumSmall>
            <div
                style={{
                    width: "100%",
                    height: "auto",
                    backgroundColor: color_white,
                    borderRadius: 10,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "start"
                }}>
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ margin: 4, width: 16, height: 16, flexShrink: 0 }}
                >
                    <path
                        d="M8.5 5.6C8.5 5.32386 8.27614 5.1 8 5.1C7.72386 5.1 7.5 5.32386 7.5 5.6L8.5 5.6ZM9.8 9.1C10.0761 9.1 10.3 8.87614 10.3 8.6C10.3 8.32386 10.0761 8.1 9.8 8.1V9.1ZM8 5.6L7.5 5.6L7.5 7.7H8H8.5L8.5 5.6H8ZM14 8H13.5C13.5 11.0376 11.0376 13.5 8 13.5V14V14.5C11.5899 14.5 14.5 11.5899 14.5 8H14ZM8 14V13.5C4.96243 13.5 2.5 11.0376 2.5 8H2H1.5C1.5 11.5899 4.41015 14.5 8 14.5V14ZM2 8H2.5C2.5 4.96243 4.96243 2.5 8 2.5V2V1.5C4.41015 1.5 1.5 4.41015 1.5 8H2ZM8 2V2.5C11.0376 2.5 13.5 4.96243 13.5 8H14H14.5C14.5 4.41015 11.5899 1.5 8 1.5V2ZM8.9 8.6V9.1H9.8V8.6V8.1H8.9V8.6ZM8 7.7H7.5C7.5 8.4732 8.1268 9.1 8.9 9.1V8.6V8.1C8.67909 8.1 8.5 7.92091 8.5 7.7H8Z"
                        fill="#222222"
                    />
                </svg>
                <OnestNormal style={{ margin: 4, fontSize: 12 }}>
                    {selectedTime}
                </OnestNormal>
            </div>
            <div
                style={{
                    marginTop: 0,
                    width: "100%",
                    height: "auto",
                    backgroundColor: color_white,
                    borderRadius: 10,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "start"
                }}>
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ margin: 4, width: 16, height: 16, flexShrink: 0 }}
                >
                    <path d="M2.0625 6.2698H13.9451" stroke="#222222" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10.962 8.87331H10.9681" stroke="#222222" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M8.00298 8.87331H8.00915" stroke="#222222" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M5.03813 8.87331H5.04431" stroke="#222222" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10.962 11.4641H10.9681" stroke="#222222" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M8.00298 11.4641H8.00915" stroke="#222222" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M5.03813 11.4641H5.04431" stroke="#222222" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10.6955 1.3335V3.52735" stroke="#222222" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M5.31075 1.3335V3.52735" stroke="#222222" strokeLinecap="round" strokeLinejoin="round"/>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.8255 2.38623H5.18064C3.22285 2.38623 2 3.47685 2 5.48158V11.5147C2 13.5509 3.22285 14.6668 5.18064 14.6668H10.8193C12.7833 14.6668 14 13.5698 14 11.5651V5.48158C14.0062 3.47685 12.7895 2.38623 10.8255 2.38623Z"
                        stroke="#222222"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <OnestNormal style={{ margin: 4, fontSize: 12 }}>
                    {moment(lessonData.dateDate).format("DD.MM.YY")}
                </OnestNormal>
            </div>
            <div
                style={{
                    marginTop: 10,
                    paddingTop: 10,
                    borderTop: "1px solid #E0E0E0",
                }}
            >
                <OnestMediumDefault style={{ fontSize: 16, margin: "0 0 10px 0" }}>
                    {t("Перенос урока")}
                </OnestMediumDefault>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 5,
                        marginBottom: 25,
                        width: "100%",
                    }}>
                    <div
                        style={{
                            ...styles.timeSelect,
                            alignSelf: "center",
                            width: isMobile ? "auto" : 189,
                            flex: isMobile ? 1 : "0 0 auto",
                            minWidth: 0,
                            backgroundColor: !isDelete ? color_grey_ultra_light : color_grey_ultra_light,
                            height: 50,
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                        }}
                    >
                        <input
                            ref={dateInputRef}
                            className="reschedule-date-input"
                            lang={locale}
                            type="date"
                            onChange={handleDateChange}
                            onBlur={() => {
                                isDatePickerOpenRef.current = false;
                            }}
                            value={selectedDate}
                            placeholder={t("ДД.ММ.ГГГГ")}
                            pattern="\d{2}\.\d{2}\.\d{4}"
                            style={{
                                border: "none",
                                outline: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                                paddingLeft: 15,
                                paddingRight: 15,
                                color: "#222222",
                                fontFamily: "Onest",
                                fontSize: 14,
                            }}
                        />
                        <button
                            type="button"
                            onMouseDown={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                const el = dateInputRef.current;
                                if (!el) return;

                                const isActive = document.activeElement === el;
                                const shouldClose = isDatePickerOpenRef.current || isActive;
                                if (shouldClose) {
                                    el.blur?.();
                                    isDatePickerOpenRef.current = false;
                                    // Иногда blur не закрывает picker, поэтому пробуем принудительно через Escape.
                                    document.dispatchEvent(
                                        new KeyboardEvent("keydown", { key: "Escape", bubbles: true })
                                    );
                                    document.body?.focus?.();
                                    return;
                                }

                                el.focus?.();
                                isDatePickerOpenRef.current = true;
                                setTimeout(() => {
                                    if (typeof el.showPicker === "function") {
                                        el.showPicker();
                                    } else {
                                        el.click?.();
                                    }
                                }, 0);
                            }}
                            style={{
                                position: "absolute",
                                right: 8,
                                border: "none",
                                background: "transparent",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                            }}
                            aria-label={t("Открыть календарь")}
                        >
                            <IconlyCurvedLightCalendar width={24} height={24} stroke="#B1B1B1" />
                        </button>
                    </div>
                    <select
                    value={selectedTime?.split(" - ")[0].split(":")[0] || ""}
                    onChange={e => {
                        const [start, end] = selectedTime?.split(" - ") || ["", ""];
                        let startMins = start.split(":")[1] ? start.split(":")[1] : "00";
                        let endHour = +end.split(":")[0];
                        let endMinute = +end.split(":")[1];

                        if (+startMins < 30) {
                            endHour = +e.target.value;
                            endMinute = +startMins + 30;
                        } else {
                            endHour = +e.target.value + 1;
                            endMinute = +startMins - 30;
                        }
                        const newStart = `${minutesToStr(e.target.value)}:${minutesToStr(startMins)}`;
                        const newEnd = `${minutesToStr(endHour)}:${minutesToStr(endMinute)}`;
                        handleTimeChange(`${newStart} - ${newEnd}`);
                    }}
                    style={{
                        ...styles.timeSelect,
                        alignSelf: "center",
                        width: timeInputWidth,
                        flexShrink: 0,
                        height: 50,
                        backgroundColor: !isDelete ? color_grey_ultra_light : color_grey_ultra_light,
                        color: !isDelete ? "#000000" : color_grey_ultra_light,
                        fontFamily: "Onest",
                        fontSize: 16,
                        fontWeight: 400,
                        appearance: "none",
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                        backgroundImage: selectArrowIcon,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "right 10px center",
                        paddingRight: 24,
                    }}
                    >
                        <option value="" disabled>{t("часы")}</option>
                        {[...Array(24).keys()].map(el => (
                            <option
                            key={`hour-${el}`}
                            value={el.toString().padStart(2, "0")}
                            style={{
                                ...styles.timeSelectOption,
                                color: "#000000",
                                fontFamily: "Onest",
                                fontSize: 16,
                                fontWeight: 400,
                            }}>
                            {el.toString().padStart(2, "0")}
                            </option>
                        ))}
                    </select>
                    <span
                        style={{
                            width: isMobile ? 4 : 5,
                            height: 20,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontFamily: "Onest",
                            fontSize: isMobile ? 14 : 16,
                            fontWeight: 400,
                            lineHeight: "20px",
                            color: "#222222",
                        }}
                    >
                        :
                    </span>
                    <select
                    value={selectedTime?.split(" - ")[0].split(":")[1] || ""}
                    onChange={e => {
                        const [start, end] = selectedTime?.split(" - ") || ["", ""];
                        let startHour = start.split(":")[0] !== "" ? start.split(":")[0] : "00";
                        let endHour = +end.split(":")[0];
                        let endMinute = +end.split(":")[1];

                        if (+e.target.value < 30) {
                            endHour = +start.split(":")[0];
                            endMinute = +e.target.value + 30;
                        } else {
                            endHour = +start.split(":")[0] + 1;
                            endMinute = +e.target.value - 30;
                        }


                        const newStart = `${minutesToStr(startHour)}:${e.target.value}`;
                        const newEnd = `${minutesToStr(endHour)}:${minutesToStr(endMinute)}`;
                        handleTimeChange(`${newStart} - ${newEnd}`);
                    }}
                    style={{
                        ...styles.timeSelect,
                        width: timeInputWidth,
                        flexShrink: 0,
                        height: 50,
                        backgroundColor: !isDelete ? color_grey_ultra_light : color_grey_ultra_light,
                        color: !isDelete ? "#000000" : color_grey_ultra_light,
                        fontFamily: "Onest",
                        fontSize: 16,
                        fontWeight: 400,
                        appearance: "none",
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                        backgroundImage: selectArrowIcon,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "right 10px center",
                        paddingRight: 24,
                    }}
                    >
                        <option value="" disabled>{t("минуты")}</option>
                        {["00", "10", "20", "30", "40", "50"].map(minute => (
                            <option
                            key={minute}
                            value={minute}
                            style={{
                                ...styles.timeSelectOption,
                                color: "#000000",
                                fontFamily: "Onest",
                                fontSize: 16,
                                fontWeight: 400,
                            }}>
                            {minute}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <OnestMediumDefault style={{ fontSize: 16, margin: "0 0 15px 0" }}>
                {t("Удаление урока")}
            </OnestMediumDefault>
            <div
                style={{
                    marginBottom: 20,
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,
                }}
            >
                <label style={{ ...styles.radioBoxRow, marginTop: 0 }}>
                    <RadioBoxEmpty
                        checked={isDelete && isPaid}
                        onChange={handleClickPayOption}
                    />
                    <OnestNormalSmall>{t("Удалить урок и списать деньги с баланса")}</OnestNormalSmall>
                </label>
                <label style={{ ...styles.radioBoxRow, marginTop: 0 }}>
                    <RadioBoxEmpty
                        checked={isDelete && !isPaid}
                        onChange={handleClickFreeOption}
                    />
                    <OnestNormalSmall>{t("Удалить урок и не списывать деньги с баланса")}</OnestNormalSmall>
                </label>
            </div>

            {isSpineActive &&
                <div style={{ margin: "8px", alignSelf: "center", display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <ClipLoader color={color_red_default} size={35} loading={isSpineActive} />
                    <OnestNormalDefault
                        style={{ margin: "8px", alignSelf: "center" }}
                    >{t("Сохранение...")}</OnestNormalDefault>
                </div>
            }

            {!isSpineActive &&
                <Button
                    width={"100%"}
                    height={60}
                    backgroundColor={isButtonDisabled ? color_grey_light : color_red_default}
                    borderColor={isButtonDisabled ? color_grey_light : color_red_default}
                    disabled={isButtonDisabled}
                    color={color_white}
                    onClick={handleRescheduleSubmit}
                >
                    <OnestNormalDefault>{t("Сохранить")}</OnestNormalDefault>
                </Button>
            }
        </ReactModal>
    );
};

export default ModalReschedule;